export type WalletConnectionAction = 'install-metamask' | 'connect-snap' | 'update-snap' | 'switch-network';

export type WalletConnectionActionReason =
  | 'wallet-not-installed'
  | 'snap-not-permitted'
  | 'snap-disabled'
  | 'snap-blocked'
  | 'snap-incompatible'
  | 'wrong-network'
  | 'wallet-data-invalid';

export class WalletConnectionActionRequiredError extends Error {
  readonly kind = 'action-required' as const;

  constructor(
    readonly action: WalletConnectionAction,
    readonly reason: WalletConnectionActionReason,
    message: string,
  ) {
    super(message);
    this.name = 'WalletConnectionActionRequiredError';
  }
}

export function isWalletConnectionActionRequiredError(error: unknown): error is WalletConnectionActionRequiredError {
  return error instanceof WalletConnectionActionRequiredError;
}

export class WalletAccessDeniedError extends Error {
  constructor(readonly stage: 'account-access' | 'snap-connection') {
    super(`MetaMask access denied (HTTP 403, ${stage})`);
    this.name = 'WalletAccessDeniedError';
  }
}

export class WalletConnectionPendingError extends Error {
  readonly code = -32002;

  constructor() {
    super(
      'MetaMask is waiting for your response. Open MetaMask and approve or cancel the connection request. Then return to Ducat and try again. If you cannot see the request, check your other Ducat tabs.',
    );
    this.name = 'WalletConnectionPendingError';
  }
}
